import React, { Fragment, useEffect, useMemo, useState } from "react";
import { Row, Col, Button, Modal, Typography, Space } from "antd";
import { Link } from "react-router-dom";
import { FaCalendarAlt } from "react-icons/fa";
import { PiNotePencilFill, PiMoneyBold } from "react-icons/pi";
import { IoLocationSharp } from "react-icons/io5";
import { IoIosPeople } from "react-icons/io";
import { FaPeopleGroup } from "react-icons/fa6";
import { KEYS } from "../../../../../../Config/Keys";
import { useNavigate } from "react-router-dom";
import FadeInImage from "../../../../../../common/Images/FadeInImage";
import { CloseRegistration } from "../../../../../../Config/API/events";
import Loader from "../../../../../../common/cards/Loader";
import { Info, error, success } from "../../../../../../common/Alerts/Message";
import { useDispatch } from "react-redux";
import { setEVENT } from "../../../../../../Store/Features/EventSlice";
import { Truncate } from "../../../../../../common/Text/Truncate";
import BookmarkEvent from "../../../../../../common/Buttons/BookmarkEvent";
import {
  combineWildCardSlots,
  segregateEventAwardsAndReturnQuantity
} from "../../../../../../utils/utilityFunctions";
import { EVENT_TYPES, GAMES_MODES } from "../../../../../../Config/helpers/constants";
import ShareModal from "../../../../../../common/Model/ShareModal";

import moment from "moment";
import { useCurrentPage } from "../../../../../../common/hooks/useCurrentPage";

const TopBar = ({ data, eventId, isOrg, panelFound, teamFound }) => {
  const [loading, setloading] = useState(false);
  const [remaining, setremaining] = useState(false);
  const [isClosed, setIsClosed] = useState(data?.registrationComplete); //event registration
  const [closeRegistrationModal, setCloseRegistrationModal] = useState(false);
  const registeredTeamsWithoutWildCards = data?.registerteams?.filter((team) => !team?.wildCard);
  const wildCardSlots = combineWildCardSlots(data?.wildCards);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { url } = useCurrentPage();
  const { Text, Title } = Typography;

  const awards = useMemo(
    () => segregateEventAwardsAndReturnQuantity(data?.awardsDetail),
    [data?.awardsDetail]
  );

  useEffect(() => {
    if (data?.registrationComplete) setIsClosed(true);
    else setIsClosed(false);
  }, [data?.registrationComplete]);

  const closeEventRegistration = async (deadlineReached = false) => {
    // check if min required teams are registered or not
    if (!deadlineReached && data?.minParicipants > registeredTeamsWithoutWildCards?.length) {
      return Info(`Minimum ${data?.minParicipants} Teams required before proceeding`);
    }
    try {
      setloading("closing");
      const res = await CloseRegistration({
        action: true,
        id: eventId
      });
      let d = await res.json();
      console.log(d);
      if (d?.type === "success") {
        success(d?.result);
        dispatch(setEVENT(d?.data));
        setCloseRegistrationModal(false);
      } else {
        error(d?.result || "Event action not completed");
      }
      setloading(false);
    } catch (e) {
      setloading(false);
      console.log(e.message);
    }
  };

  // not needed yet
  // check if Group Stage type event has enough teams
  // const CheckGroupStageCloseRegistration = async () => {
  //   const noOfTeams = data?.registerteams?.length;
  //   if (noOfTeams === 0) return Info(` ${data?.minParicipants} Registered Teams required!`);
  //   if ((noOfTeams & (noOfTeams - 1)) !== 0 || noOfTeams < 2)
  //     return Info("Registered teams should be 2,4,8,16,32,64....");
  //   else {
  //     return closeEventRegistration();
  //   }
  // };
  // const CheckDKOCloseRegistration = async () => {
  //   const noOfTeams = data?.registerteams?.length;
  //   if (noOfTeams === 0 || noOfTeams < 4) return Info(` minimum 4 Teams are required!`);
  //   else {
  //     return closeEventRegistration();
  //   }
  // };
  useEffect(() => {
    setremaining(
      parseInt(data?.maxParicipants) - parseInt(registeredTeamsWithoutWildCards?.length)
    );
  }, [data?.maxParicipants, data?.registerteams?.length]);

  // auto close registration after deadline
  // commenting for now
  // useEffect(() => {
  //   if (data?.deadline && eventId && !data?.registrationComplete) {
  //     const currentDate = moment().startOf("day");
  //     const deadline = moment(data?.deadline).startOf("day");

  //     // Compare the dates
  //     const isDeadlinePassed = currentDate.isAfter(deadline);

  //     console.log("deadline", deadline, "current:", currentDate);
  //     // if registration deadline is complete close the registration
  //     if (isDeadlinePassed) {
  //       closeEventRegistration(true);
  //     }
  //   }
  // }, [data, eventId]);

  useEffect(() => {
    return () => {
      setloading(null);
      setIsClosed(null);
    };
  }, []);

  const handleScheduleClick = () => {
    if (data?.typeofmatch === GAMES_MODES.knockOut) {
      navigate(`/organizer/event/${eventId}/knock-out-schedule`, { state: data });
    } else {
      navigate(`/organizer/event/${eventId}/schedule`, { state: data });
    }
  };
  const canregister = () => {
    const isFullSlots =
      data?.maxParicipants && registeredTeamsWithoutWildCards?.length === data?.maxParicipants;

    const cregister =
      new Date(data?.deadline).setHours(24) > new Date() &&
      data?.registrationComplete === false &&
      !isFullSlots;
    return cregister;
  };
  const OrganizerButtons = () => {
    return isOrg ? (
      <Col className="timelineemptyslots" lg={12} md={24} xs={24} sm={24}>
        <div className="EventPlayerButtons">
          <div>
            <Button
              onClick={() => navigate(`/organizer/event/${eventId}/event-awards`)}
              style={{
                borderRadius: "5rem",
                width: "45%",
                margin: "0"
              }}
              className="registerbutton btnMobileDimensions"
              type="primary">
              View Awards
            </Button>
            {!data?.scheduleComplete ? (
              <Button
                onClick={() => navigate(`/organizer/editevent/${eventId}`)}
                style={{
                  borderRadius: "5rem",
                  width: "45%",
                  margin: "0"
                }}
                className="registerbutton btnMobileDimensions"
                type="primary">
                Edit
              </Button>
            ) : null}
            {isClosed ? (
              <Button
                style={{
                  borderRadius: "5rem",
                  width: "45%",
                  margin: "0",
                  background: "var(--blue)",
                  borderColor: "var(--blue)"
                }}
                onClick={handleScheduleClick}
                className="registerbutton btnMobileDimensions"
                type="primary">
                Schedule
              </Button>
            ) : (
              <Button
                style={{
                  borderRadius: "5rem",
                  width: "45%",
                  margin: "0"
                }}
                onClick={() => setCloseRegistrationModal(true)}
                // onClick={() => {
                //   if (data?.typeofmatch === "ko" || data?.typeofmatch === "knockout") {
                //     closeEventRegistration();
                //   } else if (data?.typeofmatch === "doubleelimination") {
                //     CheckDKOCloseRegistration();
                //   } else if (data?.typeofmatch === "multiplayer") {
                //     closeEventRegistration();
                //   } else {
                //     if (data?.registerteams?.length >= 2) CheckGroupStageCloseRegistration();
                //     else Info("Minimum 2 teams are required for schedule!");
                //   }
                // }}
                className="registerbutton closeButton btnMobileDimensions"
                type="primary">
                Close Registration
              </Button>
            )}
            <div className="d-block-786" style={{ display: "none", alignItems: "center" }}>
              <BookmarkEvent
                style={{
                  marginBottom: "0px",
                  position: "unset"
                }}
              />
            </div>
          </div>
          <Row justify="end">
            <BookmarkEvent />
          </Row>
        </div>
      </Col>
    ) : null;
  };

  const BannerSection = () => {
    return (
      <div className="banner-container banner-side-wrapper">
        <div className="banner-side left">
          <div className="banner-mode">
            <div className="mode-label">{data?.type ?? "tournament"}</div>
            <img className="mode-tag" src="/images/tag.svg" />
          </div>

          <div className="banner-details">
            <div className="detail-row">
              <PiMoneyBold className="icon" size={28} />
              {data?.fee}
            </div>
            <div className="detail-row">
              <FaPeopleGroup className="icon" size={28} />
              {(data?.maxParicipants || 0) + (wildCardSlots?.noOfSlots || 0)}
            </div>
          </div>

          {canregister() && (
            <div className="banner-deadline">
              <Text className="deadline-label">Deadline:</Text>
              <Text className="deadline-date">
                {moment(data?.deadline).format("D-MMM-YYYY")}{" "}
                {data?.type === EVENT_TYPES.SCRIM ? data?.deadlineTime : ""}
              </Text>
            </div>
          )}

          <div className="banner-button-group">
            {canregister() ? (
              <Button
                type="primary"
                size="large"
                className="registerbutton btnMobileDimensions mb-2">
                Registration Open
              </Button>
            ) : wildCardSlots?.occupiedSlots < wildCardSlots?.noOfSlots ? (
              <>
                <Button
                  type="primary"
                  size="large"
                  className="registerbutton btnMobileDimensions mb-2 warning">
                  Registration Closed
                </Button>
                <Text className="wildcard-info">Wildcards entries are available</Text>
              </>
            ) : (
              <Button
                type="primary"
                size="large"
                className="registerbutton btnMobileDimensions mb-2 warning">
                Registration Closed
              </Button>
            )}
          </div>
        </div>

        <div className="banner-image-wrapper">
          <FadeInImage radius preview type="eventCover" src={KEYS.API + data?.file?.fileUrl} />
        </div>

        <div className="banner-side right">
          <div className="banner-awards">
            <Title level={3} className="section-title">
              Awards:
            </Title>

            <div className="award-item award-item-b">
              <img className="icon" height="42px" src="/images/icons/cash.svg" />
              <span>Rs. {awards?.cash || 0}</span>
            </div>

            <div className="award-item">
              <img className="icon" height="32px" src="/images/icons/certificate.svg" />
              <span>{awards?.certificate || 0} Certificate(s)</span>
            </div>

            <div className="award-item">
              <img className="icon" height="32px" src="/images/icons/shield.svg" />
              <span>{awards?.shield || 0} Shield(s)</span>
            </div>

            <Text className="show-details">Show Details</Text>
          </div>

          <div className="banner-sponsors">
            <Title level={3} className="section-title">
              Sponsors:
            </Title>
            <div className="sponsor-logos">
              <div className="sponsor-logo"></div>
              <div className="sponsor-logo"></div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Fragment>
      {loading === "closing" ? <Loader fullpage /> : null}
      <Row className="eventtoheader">
        <Col span={24}>
          <BannerSection />
        </Col>
        <Col className="timelinetopbarshadow" lg={isOrg ? 24 : 24} md={24} xs={24} sm={24}>
          <div className="timelinetopbarpadding">
            <Row justify="space-between">
              <Col>
                <Space>
                  <p className="timelinetopdata">
                    <FaCalendarAlt />
                    <span style={{ marginLeft: "5px" }}>
                      {moment(data?.startDate).format("MMM D, YYYY") + " - " + data?.type !==
                      EVENT_TYPES.SCRIM
                        ? moment(data?.endDate).format("MMM D, YYYY")
                        : null}
                    </span>
                  </p>
                </Space>
              </Col>
              <Col>
                {data?.nameofsports && (
                  <p className="timelinetoptype">
                    {data?.typeofsports} -{" "}
                    {data?.nameofsports?.charAt(0).toUpperCase() + data?.nameofsports?.slice(1)}
                  </p>
                )}
              </Col>
            </Row>
            <Row justify="space-between" alignItems="center">
              <Col>
                <div className="timelinefonttitle E_font ">
                  <Truncate text={data?.name} lines={2} level={4} />{" "}
                  <PiNotePencilFill
                    onClick={() => navigate(`/organizer/editevent/${eventId}`)}
                    style={{ cursor: "pointer" }}
                  />
                </div>
                <p className=" flexcenter">
                  <IoIosPeople style={{ fontSize: "1.2rem", color: "#6b6b6b" }} />
                  <span className="sideItemsText">
                    Organized by{" "}
                    <Link
                      state="panel"
                      to={`/view/panel/${data?.panel?._id}/timeline`}
                      style={{ color: "#0085ff", paddingRight: "0.5rem" }}>
                      {data?.panel?.name}
                    </Link>
                  </span>
                </p>
                {data?.type !== EVENT_TYPES.SCRIM && (
                  <p style={{ color: "#0FC5FF", display: "flex", alignItems: "center" }}>
                    <IoLocationSharp style={{ fontSize: "1rem" }} />
                    <span style={{ marginLeft: "5px", fontSize: "0.9rem", fontWeight: "500" }}>
                      {data?.city || "-"}
                    </span>
                  </p>
                )}
              </Col>
              <Col className="toshare">
                <ShareModal relativeUrl={`/view/event/${eventId}`} />
              </Col>
            </Row>
            <Row justify="space-between">
              <Col lg={12} md={14} xs={24} sm={24}>
                <Row justify="space-between">
                  <Col lg={8} sm={8} xs={8} md={12}>
                    <p className="E_slot">
                      Max Slots :
                      <span className="timelineslotscolor">{data?.maxParicipants || 0}</span>
                    </p>
                  </Col>

                  <Col lg={8} sm={8} xs={8} md={12}>
                    <p className="E_slot">
                      Min Slots :
                      <span className="timelineslotscolor">{data?.minParicipants || 0}</span>
                    </p>
                  </Col>

                  <Col lg={8} sm={8} xs={8} md={12}>
                    {data?.type !== EVENT_TYPES.SCRIM && (
                      <p className="E_slot">
                        Total Wildcards :
                        <span className="timelineslotscolor">{wildCardSlots?.noOfSlots || 0}</span>
                      </p>
                    )}
                  </Col>

                  <Col lg={8} sm={8} xs={8} md={12}>
                    <p className="E_slot">
                      Occupied Slots:
                      <span className="timelineslotscolor">
                        {registeredTeamsWithoutWildCards?.length || 0}
                      </span>
                    </p>
                  </Col>

                  <Col lg={8} sm={8} xs={8} md={12}>
                    <p className="E_slot">
                      Remaining Slots :<span className="timelineslotscolor">{remaining || 0}</span>
                    </p>
                  </Col>

                  <Col lg={8} sm={8} xs={8} md={12}>
                    <p className="E_slot">
                      Occupied Wild Slots :
                      <span className="timelineslotscolor">
                        {wildCardSlots?.occupiedSlots || 0}
                      </span>
                    </p>
                  </Col>
                </Row>
              </Col>
              <OrganizerButtons />
            </Row>
          </div>
        </Col>
      </Row>

      <Col xl={24} lg={24} md={17} sm={15} xs={24} className="header-tabs">
        <Row className="subnavLinks header-tabs-row">
          <Col className="tosubnavcenter">
            <Link to={`/organizer/event/${eventId}/timeline`}>
              <p className={url === "timeline" ? "toactive" : null}> Timeline</p>
            </Link>
          </Col>
          {(panelFound || teamFound) && (
            <Col className="tosubnavcenter">
              <Link to={`/organizer/event/${eventId}/announcements`}>
                <p className={url === "announcements" ? "toactive" : null}> Announcements </p>
              </Link>
            </Col>
          )}
          <Col className="tosubnavcenter">
            <Link to={`/organizer/event/${eventId}/about`}>
              <p className={url === "about" ? "toactive" : null}>About</p>
            </Link>
          </Col>
          <Col className="tosubnavcenter">
            <Link to={`/organizer/event/${eventId}/registerteams`}>
              <p className={url === "registerteams" ? "toactive" : null}>Registered Teams</p>
            </Link>
          </Col>
        </Row>
      </Col>

      {closeRegistrationModal && (
        <Modal
          title="Close Registration Confirmation"
          open={closeRegistrationModal}
          onOk={closeEventRegistration}
          onCancel={() => setCloseRegistrationModal(false)}>
          <Text strong>Are you sure you want to close registration ?</Text>
          <blockquote>Once registrations are closed, they can not be reopened.</blockquote>
        </Modal>
      )}
    </Fragment>
  );
};

export default TopBar;
